import { render, staticRenderFns } from "./TATManagement.vue?vue&type=template&id=42e6b70c&scoped=true"
import script from "./TATManagement.vue?vue&type=script&lang=js"
export * from "./TATManagement.vue?vue&type=script&lang=js"
import style0 from "./TATManagement.vue?vue&type=style&index=0&id=42e6b70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6b70c",
  null
  
)

export default component.exports